module.exports = __webpack_public_path__ + "img/bg-img-3.f52b9beb.png";